import { config } from "../env";
import { get, patch, patchWitoutPayload, post } from "./helpers/http-handler";

export const getSelfComplianceList = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance?${queryRequest}`);

export const getSpecificSelfComplianceList = (id: string) =>
  get(`${config.API_URL}/self-compliance/${id}`);

export const addSelfComplianceList = (payload: object) =>
  post(`${config.API_URL}/self-compliance`, payload);

export const updateSelfComplianceListStatus = (payload: object) =>
  patch(`${config.API_URL}/self-compliance/bulk/change-status`, payload);

export const configureSelfCompliance = (payload: object) =>
  post(`${config.API_URL}/self-compliance/configure`, payload);

export const downloadSelfCompliance = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance/export/data?${queryRequest}`);

export const getSelfComplianceTaskList = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance-task?${queryRequest}`);

export const updateSelfComplianceListUser = (payload: object) =>
  patch(`${config.API_URL}/self-compliance-task/bulk/change-user`, payload);

//activity

export const UpdateSelfComplianceTask = (id: string, payload: object) =>
  patch(`${config.API_URL}/self-compliance-task/${id}`, payload);

export const UpdateMultipleSelfComplianceTask = (payload: object) =>
  patch(`${config.API_URL}/self-compliance-task/bulk/update`, payload);

export const getSpecificSelfComplianceTask = (id: string) =>
  get(`${config.API_URL}/self-compliance-task/${id}`);

export const getSpecificSelfComplianceTaskExecutor = (id: string) =>
  get(`${config.API_URL}/self-compliance-task/executor/${id}`);

export const getSpecificSelfComplianceTaskEvaluator = (id: string) =>
  get(`${config.API_URL}/self-compliance-task/evaluator/${id}`);

export const getSpecificSelfComplianceTaskHistory = (
  id: string,
  queryRequest: string
) =>
  get(
    `${config.API_URL}/self-compliance-task/${id}/task-history?${queryRequest}`
  );
//activity -> calender

export const getActivityMyTaskCalenderInfo = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/view/calendar-view?${queryRequest}`
  );

export const bulkUpdateSelfComplianceTask = (payload: object) =>
  patch(`${config.API_URL}/self-compliance-task/bulk/active-inactive`, payload);

export const SelfComplainceTaskUploadDocument = (id: string, payload: object) =>
  patch(`${config.API_URL}/self-compliance-task/${id}/document`, payload);

export const SelfComplainceUpdateStatusToReportedNonComplied = (id: string) =>
  patchWitoutPayload(
    `${config.API_URL}/self-compliance-task/${id}/reported-non-complied`
  );

export const UpdateVendorSetting = (payload: object) =>
  patch(`${config.API_URL}/organisation/admin/active-email`, payload);

export const updateSelfComplianceAuditorComment = (
  id: string,
  payload: object
) =>
  patch(`${config.API_URL}/self-compliance-task/audit-comment/${id}`, payload);

export const getSelfComplianceTaskInterlinkedTasks = (
  id: string,
  queryRequest: string
) =>
  get(
    `${config.API_URL}/self-compliance-task/interlinked-tasks/${id}?${queryRequest}`
  );
